import { SUPPORTED_CATEGORIES_WITH_SEGMENTS_METRICS } from "app/components/dashboard/widget-wizard/constants";
import { GraphWidget } from "./GraphWidget";
import { WidgetState } from "./Widget";

export class IndustryEngagementVisitsGraphWidget extends GraphWidget {
    constructor() {
        super();
    }

    static getWidgetMetadataType() {
        return "IndustryEngagementVisitsGraph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    public isPptSupported = () => {
        return false;
    };

    public getData() {
        const isSegmentsAvailable = SUPPORTED_CATEGORIES_WITH_SEGMENTS_METRICS.includes(this._params.metric);

        if (isSegmentsAvailable) {
            const state = this._reduxService.getState();
            let isEnabled = true;

            if (this.id) {
                const segmentWidgetAvailability = state.segmentsModule?.segmentWidgetAvailability?.[this.id];

                if (segmentWidgetAvailability) {
                    isEnabled = segmentWidgetAvailability?.isEnabled;
                }
            }

            if (!isEnabled) {
                this.widgetState = WidgetState.SOFT_LIMIT_REACHED;

                return;
            }
        }

        return super.getData();
    }
}

IndustryEngagementVisitsGraphWidget.register();
